/* @flow */
import { pull, includes } from 'lodash';

import Store from 'lib/Store';
import Organization from 'entities/Organization';
import Organizations from 'collections/Organizations';
import OrganizationStore from 'stores/OrganizationStore';
import { removeRole, isMember } from 'shapes/Affiliation';

import { ActionTypes as OrganizationActionTypes } from '../constants/OrganizationConstants';

// This is the current user organization affiliations store.
class AffiliationStore extends Store {
  getInitialState() {
    return {
      // Store orgIds in a separate array to preserve ordering
      orgIds: [],
      affiliations: {},
      loaded: false,
    };
  }

  isLoaded() {
    return this.state.loaded;
  }

  getAffiliation(organizationId: number) {
    return this.state.affiliations[organizationId];
  }

  getAffiliations() {
    return this.state.orgIds.map(id => this.state.affiliations[id]);
  }

  getAffiliatedOrganizationsIds(): number[] {
    return Object.keys(this.state.affiliations).map(s => Number(s));
  }

  getAffiliatedOrganizations() {
    return new Organizations(
      this
        .getAffiliatedOrganizationsIds()
        .map(id => OrganizationStore.getOrganization(id))
        .filter(o => !!o)
    );
  }

  getMemberOrganizations() {
    return this.getAffiliations()
      .filter(isMember)
      .map(aff => OrganizationStore.getOrganization(aff.organization_id))
      .filter(o => !!o);
  }

  parseOrganization(organization: Organization) {
    const aff = organization.get('user_affiliation');
    if (aff) {
      aff.organization_id = organization.id;
      if (!includes(this.state.orgIds, organization.id)) {
        this.state.orgIds.push(organization.id);
      }
      this.state.affiliations[organization.id] = aff;
    }
  }

  handleDispatch(action: Object): void {
    switch (action.type) {
      case OrganizationActionTypes.LOAD_USER_ORGANIZATIONS:
        this.handleLoadAll(action.organizations);
        break;
      case OrganizationActionTypes.REMOVE_ORGANIZATION:
        delete this.state.affiliations[action.orgId];
        this.state.orgIds = pull(this.state.orgIds, action.orgId);
        this.emitChange();
        break;
      case OrganizationActionTypes.LOAD_ORGANIZATION:
        this.parseOrganization(action.organization);
        this.emitChange();
        break;
      case OrganizationActionTypes.REMOVE_ADMIN_ROLE: {
        const oldAff = this.state.affiliations[action.orgId];
        this.state.affiliations[action.orgId] = removeRole(oldAff, 'admin');
        this.emitChange();
        break;
      }
      case OrganizationActionTypes.UPDATE_CURRENT_USER_ORGANIZATION_AFFILIATION: {
        this.state.affiliations[action.organizationId] = action.affiliation;
        this.emitChange();
        break;
      }
      default:
        break;
    }
  }

  handleLoadAll(organizations: Organizations) {
    this.state.affiliations = {};
    this.state.orgIds = [];
    organizations.forEach(organization => this.parseOrganization(organization));
    this.state.loaded = true;
    this.emitChange();
  }
}

export default new AffiliationStore();



// WEBPACK FOOTER //
// ./src/stores/AffiliationStore.js